import { useStore } from 'vuex';

export async function hasPermissions(permission) {
  const store = useStore();
  return await store.getters['auth/hasPermission'](permission);
}
